import { render, staticRenderFns } from "./ParticipantsSection.vue?vue&type=template&id=2541fccf&scoped=true&"
import script from "./ParticipantsSection.vue?vue&type=script&lang=js&"
export * from "./ParticipantsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsSection.vue?vue&type=style&index=0&id=2541fccf&prod&lang=css&"
import style1 from "./ParticipantsSection.vue?vue&type=style&index=1&id=2541fccf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2541fccf",
  null
  
)

export default component.exports